import React from 'react';

type Props = {
	children: React.ReactNode;
	compact?: boolean;
};

export default function EntertainerShell({ children, compact = false }: Props) {
	return (
		<main className="entertainer-page">
			<div className={`entertainer-shell${compact ? ' compact' : ''}`}>
				<header className="entertainer-shell-header">
					<img src="/assets/images/login-logo" alt="Goodwill Projects" />
				</header>
				{children}
			</div>
		</main>
	);
}
